import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Restrictions } from './../../models/vehicles/vehicle-information-response';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-vehicle-restrictions',
  templateUrl: './modal-vehicle-restrictions.component.html',
  styleUrls: ['./modal-vehicle-restrictions.component.scss']
})
export class ModalVehicleRestrictionsComponent implements OnInit {
  restrictions: Restrictions;

  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef
  ) { 
    this.restrictions = {
      financialRestriction: this.config.data?.info?.financialRestriction,
      tenantRestriction: this.config.data?.info?.tenantRestriction,
      administrativeRestriction: this.config.data?.info?.administrativeRestriction,
      judicialRestriction: this.config.data?.info?.judicialRestriction,
      taxRestriction: this.config.data?.info?.taxRestriction,
      judicialBlock: this.config.data?.info?.judicialBlock,
      theft: this.config.data?.info?.theft,
    }
  }

  ngOnInit(): void {
  }

  public onClose(): void {
    this.ref.close();
  }

}
